import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import 'pace-progressbar';

@Component({
  selector: 'app-pace-loader',
  templateUrl: './app-pace-loader.component.html',
  styleUrls: ['./app-pace-loader.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class AppPaceLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
